import { render, staticRenderFns } from "./PIXQRCodeCard.vue?vue&type=template&id=c2f31f0e&scoped=true"
import script from "./PIXQRCodeCard.vue?vue&type=script&lang=js"
export * from "./PIXQRCodeCard.vue?vue&type=script&lang=js"
import style0 from "./PIXQRCodeCard.vue?vue&type=style&index=0&id=c2f31f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f31f0e",
  null
  
)

export default component.exports